import moment from "moment-timezone";

export const appDate = (date: string, format: string | null = null) => {
  const tz = moment.tz.guess()
  if (!date) return "";
  if (!format) {
    const formattedDate = moment(date).tz(tz).format("M.D.YY");
    const formattedTime = moment(date).tz(tz).format("h:mm A");
    return `${formattedDate}\u00A0\u00A0|\u00A0\u00A0${formattedTime}`;
  } else {
    return moment(date).tz(tz).format(format);
  }
};